import { NewWindowLink } from "~/v2/components/common";
import type { FAQItem } from "~/v2/components/common/FAQ";
import { TERMS_AND_CONDITIONS_URL } from "../const";

export const OVERVIEW_FAQ: FAQItem[] = [
  {
    question: "What is a Portfolio Transfer?",
    answer: (
      <>
        Transfer of the eligible assets from your outside brokerage account is
        done through the Automated Customer Account Transfer Service (ACATS).
      </>
    ),
  },
  {
    question: "What types of assets can I transfer to Alpaca?",
    answer: (
      <>
        US stocks, ETFs, cash balances, and margin balances (for eligible
        accounts).
      </>
    ),
  },
  {
    question: "Are there any fees to transfer my portfolio into Alpaca?",
    answer: (
      <>
        Your outside brokerage may charge you a transfer fee. Alpaca will
        reimburse you $50 for transfers of $10,000 or more per account and
        outside brokerage.
        <br />
        <br />
        <NewWindowLink to={TERMS_AND_CONDITIONS_URL}>
          Terms & Conditions
        </NewWindowLink>
      </>
    ),
  },
  {
    question: "How long does it take to complete the transfer?",
    answer: (
      <>
        It can take anywhere from 5-7 business days for assets to settle but
        cost basis data can arrive later.
      </>
    ),
  },
];
